import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
    buildShareholderHoldingsPath,
    getShareholderHolderFromSearch,
} from '../util/shareholderHoldings'

export const useShareholderHoldingsRouteRedirect = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const { isOpen, holderName, exactHolderMatch } = getShareholderHolderFromSearch(searchParams.toString())

    useEffect(() => {
        if (!isOpen) {
            return
        }
        navigate(buildShareholderHoldingsPath(holderName, { exact: exactHolderMatch }), { replace: true })
    }, [exactHolderMatch, holderName, isOpen, navigate])
}
